module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container mt-3"
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('b-row', {
    staticClass: "treasury-logo p-1",
    attrs: {
      "align-v": "end"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('img', {
    staticClass: "p-1",
    attrs: {
      "src": require("@/assets/images/grb.svg")
    }
  })]), _vm._v(" "), _c('b-col', [_c('div', {
    staticClass: "p-2"
  }, [_c('label', [_vm._v("РЕПУБЛИКА СРБИЈА")]), _vm._v(" "), _c('label', [_vm._v("МИНИСТАРСТВО ФИНАНСИЈА")]), _vm._v(" "), _c('label', {
    staticClass: "heavy-text"
  }, [_vm._v("УПРАВА ЗА ТРЕЗОР")])])])], 1), _vm._v(" "), _c('h3', {
    staticClass: "mt-5 mb-3 heavier-text"
  }, [_vm._v("Централни регистар фактура")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "p-1"
  }, [_vm._v("\n            Министарство финансија спроводи мере и активности у вези са контролом преузетих обавеза у јавном сектору\n            што између осталог подразумева евидентирање, праћење и извештавање о неизмиреним обавезама.\n            За обављање поменутих активности успостављен је информациони систем под називом Централни регистар фактура (ЦРФ).\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-card', {
    staticClass: "text-center",
    attrs: {
      "bg-variant": "warning",
      "text-variant": "white"
    }
  }, [_c('b-card-text', [_c('span', {
    staticClass: "heavier-text"
  }, [_c('b-link', {
    attrs: {
      "href": "https://www.trezor.gov.rs/files/services/crf/Obave%C5%A1tenje%20%20KJS%20%E2%80%93%2014.03.2023.%20godine.pdf"
    }
  }, [_vm._v("Хитно обавештење о поступању корисника јавних средстава")])], 1)])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-card', {
    staticClass: "text-center",
    attrs: {
      "bg-variant": "danger",
      "text-variant": "white",
      "header": "Обавезе корисника јавних средстава (КЈС) 01.05.2022. по Закону о електронском фактурисању"
    }
  }, [_c('b-card-text', [_vm._v("\n                Према одредбама Закона о електронском фактурисању („Сл. гласник РС”, бр. 44/2021 и 129/21), већина корисника јавних средстава сматрају се субјектима јавног сектора. "), _c('br'), _vm._v(" "), _c('b-alert', {
    staticClass: "my-3",
    attrs: {
      "variant": "success",
      "show": ""
    }
  }, [_c('strong', [_vm._v("Од 1. маја 2022. године субјекти јавног сектора имаће обавезу да користе Систем електронских фактура, који омогућава и приступ и коришћење Централног регистра фактура. Период до ступања на снагу обавеза неопходно је искористити како би сви државни органи и организације, као и јавна предузећа, на време и у потпуности били спремни за почетак обавезне примене.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Почетак примене права и обавеза:")])])], 1), _c('br'), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "text-left pl-3"
  }, [_c('strong', [_vm._v("1.  обавеза субјекта јавног сектора да прими и чува електронску фактуру издату у складу са Законом, обавеза издавања електронске фактуре другом субјекту јавног сектора, као и обавеза да електронски евидентира обрачун пореза на додату вредност, примењују се од "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("1. маја 2022. године")]), _vm._v(", а регистровање примаоца "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("по аутоматизму")]), _vm._v(" за субјекте јавног сектора вршиће се непосредно уочи наведеног рока, "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("уколико се претходно није регистровао")]), _vm._v(";")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "text-left pl-3"
  }, [_c('strong', [_vm._v("2.  обавеза субјекта јавног сектора да изда електронску фактуру субјекту приватног сектора, у складу са Законом, примењује се од "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("1. јула 2022. године.")])])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Субјект јавног сектора који има више нивоа сагласности и који не поседује свој систем, или део система за управљање фактурама, може да прима електронске фактуре преко "), _c('b-link', {
    attrs: {
      "href": "https://www.efaktura.gov.rs/"
    }
  }, [_vm._v("Система за управљање фактурама")]), _vm._v(", који је бесплатан за коришћење.")], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("ВАЖНЕ НАПОМЕНЕ:")])])], 1), _c('br'), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "text-left pl-3"
  }, [_vm._v("•    "), _c('strong', [_vm._v("Електронска фактура сматра се достављеном у тренутку издавања.")])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "text-left pl-3"
  }, [_vm._v("•    Прималац електронске фактуре проверава послату електронску фактуру приступом систему електронских фактура и "), _c('strong', [_vm._v("прихвата је или одбија у року од 15 дана")]), _vm._v(" од дана пријема електронске фактуре.")])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "text-left pl-3"
  }, [_vm._v("•    "), _c('strong', [_vm._v("Ако прималац")]), _vm._v(" електронске фактуре који је субјект јавног сектора "), _c('strong', [_vm._v("не прихвати или не одбије електронску фактуру")]), _vm._v(" издату од стране издаваоца електронске фактуре, електронска фактура по истеку рока од 15 дана аутоматски добија статус „прихваћена” и по закону сматра се прихваћеном.")])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "text-left pl-3"
  }, [_vm._v("•    Електронска фактура послата примаоцу путем система електронских фактура представља "), _c('strong', [_vm._v("веродостојну исправу")]), _vm._v(".")])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "text-left pl-3"
  }, [_vm._v("•    Све релевантне информације везане за електронско фактурисање доступне су на порталу еФактура на следећој адреси: "), _c('b-link', {
    attrs: {
      "href": "https://www.efaktura.gov.rs/"
    }
  }, [_vm._v("https://www.efaktura.gov.rs/")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "heavier-text",
    staticStyle: {
      "color": "#aaaaaa"
    }
  }, [_vm._v(" Погледајте "), _c('a', {
    staticStyle: {
      "color": "gray"
    },
    attrs: {
      "href": "/docs/user/register"
    }
  }, [_vm._v("документацију за регистровање")]), _vm._v(" правног лица")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-row', {
    staticClass: "mt-3 heavier-text",
    attrs: {
      "align-h": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.changelogPath
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('general.changelog')))])])]), _vm._v(" "), _c('b-row', {
    staticClass: "mt-5 heavier-text",
    attrs: {
      "align-h": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.supportPath
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('general.technicalSupport')))])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c8ae859","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StartPage.vue
// module id = 767
// module chunks = 1